module.exports = __webpack_public_path__ + "media/images/a_one-be9bb7f9fec7beab1b7b542a6643c5b8.png";